import PropTypes from "prop-types";
import Button from "@shared/v2/Button";
import Typography from "@shared/v2/Typography";
import { ArrowUpRightFromSquareSolidV6, SolidWindowSlash } from "@shared/v2/Icomoon";

const NoWebsites = ({ target }) => (
  <div className="tw-flex-1 tw-flex tw-justify-center tw-items-center">
    <div className="tw-flex tw-flex-col tw-gap-[24px] tw-w-full tw-max-w-[448px]">
      <div className="tw-flex tw-justify-center">
        <SolidWindowSlash />
      </div>
      <Typography variant="headline2" className="tw-text-center">
        You don&apos;t have any Brivity websites set up yet.
      </Typography>
      <div className="tw-flex tw-flex-col tw-gap-[8px]">
        <Typography variant="body-m" className="tw-text-center">
          Brivity offers customizable, responsive, IDX websites designed to capture leads and enhance your
          online presence. Features include eye-catching designs, mobile-friendly interfaces, home valuations,
          and an extensive property search. All of these features seamlessly integrate with your CRM!
        </Typography>
        <Typography variant="body-m" className="tw-text-center">
          Please reach out to our support team to gain access to the {target} and many other awesome website
          features!
        </Typography>
      </div>
      <div className="tw-flex tw-flex-wrap tw-justify-center tw-gap-[12px]">
        <Button
          size="medium"
          onClick={() => {
            window.Intercom?.("show");
          }}
        >
          Start A Chat
        </Button>
        <Button
          onClick={() => window.open("https://www.brivity.com/idx-websites", "_blank")}
          size="medium"
          schema="secondary"
          className="tw-flex tw-items-center tw-gap-[6px]"
        >
          Learn More <ArrowUpRightFromSquareSolidV6 />
        </Button>
      </div>
    </div>
  </div>
);

NoWebsites.propTypes = {
  target: PropTypes.string,
};

NoWebsites.defaultProps = {
  target: "blog",
};

export default NoWebsites;
